import { render, staticRenderFns } from "./ScrapCauses.vue?vue&type=template&id=6e1205a2"
import script from "./ScrapCauses.vue?vue&type=script&lang=ts"
export * from "./ScrapCauses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports